<template>
  <div class="company-config-management">
    <el-card>
      <div slot="header">
        <span>公司信息配置</span>
      </div>

      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入公司名称"></el-input>
        </el-form-item>

        <el-form-item label="公司英文名称" prop="nameEn">
          <el-input v-model="form.nameEn" placeholder="请输入公司英文名称"></el-input>
        </el-form-item>

        <el-form-item label="公司宣传语" prop="slogan">
          <el-input v-model="form.slogan" type="textarea" :rows="3" placeholder="请输入公司宣传语"></el-input>
        </el-form-item>

        <el-form-item label="公司地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入公司地址"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="联系邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入联系邮箱"></el-input>
        </el-form-item>

        <el-form-item label="公司Logo" prop="logoUrl">
          <el-upload
              class="avatar-uploader"
              :action="uploadConfig.action"
              :headers="uploadConfig.headers"
              :show-file-list="false"
              :on-success="handleLogoSuccess"
              :before-upload="beforeLogoUpload">
            <div v-if="form.logoUrl" class="avatar-preview">
              <img :src="$http.getFullImageUrl(form.logoUrl)" class="avatar">
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸：200x60像素，支持jpg、png格式，大小不超过2MB</div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">保存配置</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button type="success" @click="previewHomepage">预览首页</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CompanyConfigManagement',
  data() {
    return {
      form: {
        id: null,
        name: '',
        nameEn: '',
        slogan: '',
        address: '',
        phone: '',
        email: '',
        logoUrl: '',
        description: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  computed: {
    uploadConfig() {
      return this.$http.getUploadConfig()
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      try {
        const response = await this.$http.get('/config/company')
        if (response.success && response.data) {
          this.form = { ...response.data }
        }
      } catch (error) {
        this.$message.error('加载配置失败')
        console.error('加载配置失败:', error)
      }
    },

    handleLogoSuccess(response) {
      if (response.success && response.data) {
        this.form.logoUrl = response.data.fileUrl
        this.$message.success('Logo上传成功')
      } else {
        this.$message.error('Logo上传失败: ' + (response.message || '未知错误'))
      }
    },

    beforeLogoUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('Logo只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('Logo大小不能超过 2MB!')
      }
      return isImage && isLt2M
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const response = await this.$http.put('/config/company', this.form)
            if (response.success) {
              this.$message.success('配置保存成功')
              this.loadConfig()
            } else {
              this.$message.error('配置保存失败: ' + response.message)
            }
          } catch (error) {
            this.$message.error('配置保存失败')
            console.error('配置保存失败:', error)
          } finally {
            this.loading = false
          }
        }
      })
    },

    resetForm() {
      this.loadConfig()
    },

    previewHomepage() {
      window.open('/', '_blank')
    }
  }
}
</script>

<style scoped>
.company-config-management {
  max-width: 800px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 200px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.3s;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}

.avatar-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
